import { ComponentProps, FC, useEffect, useRef } from "react";

/**
 * コンテンツに合わせて自動で高さを調整するiframe
 * @param props
 * @returns
 */
export const Iframe: FC<ComponentProps<"iframe">> = (props) => {
  const ref = useRef<HTMLIFrameElement>(null);

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      const data = event.data as { type: string; url: string };

      if (data.type === "loaded" && data.url === props.src && ref.current) {
        ref.current.height = `${ref.current.contentWindow?.document.body.scrollHeight}px`;
      }
    };
    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  });

  return <iframe title="iframe" {...props} ref={ref} />;
};
